import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Booking } from '../../Shared/Types/bookingTypes';


export const bookingsApi = createGenericApiSlice<Booking>({
	reducerPath: "bookingsApi",
	tag: TagTypes.Booking,
	endpoint: "bookings",
});

export const {
	useGetAllQuery: useGetBookingsQuery,
	useGetByIdQuery: useGetBookingByIdQuery,
	useCreateMutation: useCreateBookingMutation,
	useUpdateMutation: useUpdateBookingMutation,
	useDeleteMutation: useDeleteBookingMutation,
} = bookingsApi;
